import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!.trim();
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!.trim();

// storageKey FIJO (02/11/2026): por defecto sale del host de la URL (sb-<ref>-auth-token). Al pasar
// de la nube a api.krilic.com.ar cambiaría y todos perderían la sesión; con la misma clave y el
// mismo JWT secret en el Supabase propio, la sesión sigue valiendo.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: { storageKey: 'sb-edgvdipxhzlpydjfqjfx-auth-token' },
});
